import { SpaceType } from "src/app/_types/space-type";

/**
 * Parametry na podstawie których wysyłane jest zapytanie do wyszukania dostępnych miejsc
 */
export class SpaceDateFilterModel {
  startDate: Date;
  endDate: Date;
  subtype: any;
  firstNameLastName: string;
  carPlate: string;
  buildings: number[];
  floors: number[];
  equipments?: number[];
  userId: string;
  equipmentId?: any; //deprecated
}

export class SpaceDateFilterOptions {
  headerDesktop: string;
  headerMobile: string;
  searchButtonText: string;
  spaceType?: SpaceType;
  subtypeSource?: string;
}
